import React from 'react'
import { Section, TaglineTitleContent, Link } from 'newComponents'
import { ReactComponent as MetricStars } from '../../../images/home/metric-stars.svg'
import { ReactComponent as LeftToggle } from '../../../images/home/metrics-left-toggle.svg'
import { ReactComponent as RightStars } from '../../../images/home/metrics-right-stars.svg'
import { ReactComponent as RightSphere } from '../../../images/home/metrics-right-sphere.svg'
import './styles.scss'

const HomeMetrics = (props) => {
  const { tagline, title, content, columns, link } = props

  const metricTagline = tagline?.html
  const metricTitle = title?.html
  const metricContent = content?.html

  return (
    <Section className="home-metrics">
      <MetricStars className="home-metrics-stars" />
      <LeftToggle className="home-metrics-left-toggle" />
      <RightSphere className="home-metrics-right-sphere" />
      <RightStars className="home-metrics-right-stars" />
      <div className="home-metrics-top">
        <TaglineTitleContent tagline={metricTagline} title={metricTitle} content={metricContent} />
      </div>

      <div className="home-metrics-columns">
        {columns.map((column) => {
          const { metrics_column_label: columnLabel, metrics_column_value: columnValue } = column

          const columnLabelText = columnLabel?.text
          const columnLabelHtml = columnLabel?.html
          const columnValueText = columnValue?.text

          return (
            <div className="home-metrics-column" key={columnLabelText}>
              <span className="home-metrics-column-value">{columnValueText}</span>
              {columnLabelHtml && (
                <div className="home-metrics-column-label" dangerouslySetInnerHTML={{ __html: columnLabelHtml }} />
              )}
            </div>
          )
        })}
      </div>
      {link && (
        <div className="home-metrics-link">
          <Link to={link.to} withChevron>
            {link.text}
          </Link>
        </div>
      )}
    </Section>
  )
}

export default HomeMetrics
